module.exports = __webpack_public_path__ + "media/images/home-icon-9f25869abb47159aa7d45f16fbbfe549.svg";